import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../../App.scss';
import {getRandomInt, randomIntFromInterval, sleep} from "../../../../Utility/Func";

class Image extends React.Component{
    constructor(props){
        super(props)
        this.state={
            radios:props.data.blur,
            xMax:87,
            xMin:12,
            yMin:6,
            yMax:93,
            x:12,
            y:6,
            level:props.data.level,
            speed:1,
        }
    }
    // image x < 87 x > 12
    // image y < 94 x > 6
    //width container - level circe = max move x
    circleInterval=async ()=>{
        let { xMax,xMin,yMax,yMin,x,y,radios,level,speed}=this.state
        let newCurrentX , newCurrentY=''
        // newCurrentX = x + speed
        // alert(level + (xMax-(level*2)-speed))
        newCurrentX = Math.floor(Math.random() * (level + (xMax-(level*2)-speed))) + 0

        // radios + random(getWidth()- (radios*2) - _stepX);
        // newCurrentY = y + speed
        // newCurrentY = y + Math.floor(Math.random() * 2) + speed
        newCurrentY = Math.floor(Math.random() * (level + (yMax-(level*2)-speed))) + 0

        if ((newCurrentX > xMax || newCurrentX < xMin) || (newCurrentY > yMax || newCurrentY < yMin)){
            // console.log('inside if ',newCurrentX,newCurrentY,speed)
            this.setState((state,props)=>({
                speed : state.speed * (-1)
            }),()=>{
                // console.log(speed)
                // this.setState({
                //     x:newCurrentX,
                //     y:newCurrentY
                // })
            })
        }


        else {
            // console.log(newCurrentX,newCurrentY)
            this.setState({
                x:newCurrentX,
                y:newCurrentY
            })
        }
    }
    componentDidMount() {
        // console.log(this.props)

        this.setState({
                speed : this.props.speed
                // speed : 1
        },()=>{
            setInterval(this.circleInterval,20)
        })
        // this.setState((state,props)=>({
        //     speed : this.props.speed
        // }))
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log(this.props.size)
    }

    render() {
        const {image,blur,imageType}=this.props.data
        const {xMax,xMin,yMax,yMin,radios,x,y}=this.state
        return(
            <>
                {
                   ( imageType ==='blur' || imageType === undefined) ? (
                        <Grid item container sm={12} style={{overflow:'hidden',borderRadius:'20px'}}>
                            <img src={image} style={{ filter: `blur(${blur}px)`,maxHeight:'300px',transition: 'clip-path 1s'}} className={'question-image'}
                                 alt="عکس موجود نیست"/>
                        </Grid>
                    ):(
                        <Grid item container sm={12} style={{background:'gray',maxHeight:'300px',overflow:'hidden'}}>
                            <img src={image} style={{
                                clipPath:blur != '0'? `circle(${radios}% at ${x}% ${y}%)`:'',
                                zIndex:'9999999999999999999'

                            }} className={'question-image'} alt=""/>
                        </Grid>
                    )
                }
            </>
        )
    }
}
export default Image